import { AbstractControl, ValidationErrors } from '@angular/forms';
import { MacAddressService } from '../services/mac-address.service';

export class AddressValidators {

  static isNumeric() {
    const addressService = new MacAddressService();
    const isControlValid = (controlValue) => {
      return (+controlValue + '' !== controlValue + '') || controlValue.length > 5;
    };

    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value) {
        const { value } = control;
        const serialNumber: string[] = addressService.createSerialNumberArray(value);
        return serialNumber.some(isControlValid) ? { isNumeric: { value: control.value } } : null;
      }
      return null;
    };
  }

  static maxSerialnumberNumbers(serialNumberLimit: number) {
    const addressService = new MacAddressService();
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value) {
        const { value } = control;
        const serialNumber: string[] = addressService.createSerialNumberArray(value);
        return serialNumber.length > serialNumberLimit ? { maxSerialnumberNumbers: { value: control.value } } : null;
      }

      return null;
    };
  }
}
